import {Storage} from "./Storage";
import {decodeAsync} from "@msgpack/msgpack";
import {getConfig} from "../configs/appConfig";
import {serialize} from "../helpers/helpers";

const storage = Storage();

export const getSluiceUrl = (sluice_type) => {

    let baseUrl = "";
    switch (sluice_type) {
        case 'auth':
            baseUrl = getConfig('auth_provider_url');
            break;
        case 'ptp_client':
            baseUrl = getConfig('ptp_client_sluice');
            break;
        case 'ptp_core':
            baseUrl = getConfig('ptp_core_sluice');
            break;
        default:
            break;
    }

    return baseUrl;
};

export const apiRequest = async (
    url,
    options,
    sluice_type,
    withToken = true,
    buildParamsCb = null,
    hasLogoutOnAuthError = true
) => {
    let baseUrl = getSluiceUrl(sluice_type);

    try {

        if (typeof options.headers === "undefined")
            options.headers = {};

        let access_token = storage.get("token") || 'null'


        if (withToken && access_token) {

            options.headers = {
                ...options.headers,
                'Authorization': "Bearer " + access_token
            }

        }

        if (sluice_type === 'ptp_core' || sluice_type === 'ptp_client' || sluice_type === false) {
            Object.assign(
                options.headers,
                {
                    'ptp-api-group-access-key': getConfig('ptp_api_group_access_key'),
                    'ptp-api-group-secret-key': getConfig('ptp_api_group_secret_key')
                }
            );
        }

        let resp = await fetch(baseUrl + url, options);
        const ok = resp.ok

        if (withToken && !ok) {
            const refreshToken = storage.get("refresh_token")
            if (refreshToken) {
                try {
                    const newTokensResp = await fetch(
                        getSluiceUrl('auth') + '/token?' + serialize({
                            grant_type: 'refresh_token',
                            refresh_token: refreshToken,
                            client_id: getConfig("auth_client_id"),
                            client_secret: getConfig("auth_client_secret")
                        }), {
                            method: 'GET',
                        })
                    if (newTokensResp.ok) {
                        const tokens = await newTokensResp.json()
                        if (tokens.refresh_token) {
                            storage.set('refresh_token', tokens.refresh_token)
                        }
                        if (tokens.access_token) {
                            storage.set('token', tokens.access_token)
                            if (buildParamsCb) {
                                const params = buildParamsCb(tokens.access_token)
                                resp = await fetch(
                                    getSluiceUrl(params.sluice_type) + params.url,
                                    params.options,
                                )
                            } else {
                                resp = await fetch(baseUrl + url, {
                                    ...(options || {}),
                                    headers: {
                                        ...(options.headers || {}),
                                        'Authorization': "Bearer " + tokens.access_token,
                                    }
                                })
                            }

                        }
                        console.log(tokens)
                    }
                } catch (error) {
                    console.log(error);
                }

            }
        }
        let json
        if (resp.headers.get("content-type").indexOf("application/json") >= 0) {
            json = await resp.json();
        } else {
            json = await decodeAsync(resp.body);
        }

        if (
            withToken &&
            !ok &&
            'error_code' in json &&
            json.error_code === 'invalid_bearer_token'
        ) {
            storage.remove('refresh_token')
            storage.remove('token')
            if (hasLogoutOnAuthError) {
                window.alert("Ваша сесія завершилась")
                window.location.reload();
            }

        }
        return json;
    } catch (e) {
        console.log(e);
    }
};
